/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../routes/__root"
import { Route as OnboardingRunsRouteImport } from "./../routes/onboarding-runs"
import { Route as FleetRouteImport } from "./../routes/fleet"
import { Route as AuditRouteImport } from "./../routes/audit"
import { Route as AllocationRouteImport } from "./../routes/allocation"
import { Route as IndexRouteImport } from "./../routes/index"
import { Route as AccountsIndexRouteImport } from "./../routes/accounts.index"
import { Route as AccountsAccountSlugRouteImport } from "./../routes/accounts.$accountSlug"
import { Route as AccountsAccountSlugIndexRouteImport } from "./../routes/accounts.$accountSlug.index"
import { Route as AccountsAccountSlugTenantsTenantSlugRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug"
import { Route as AccountsAccountSlugTenantsTenantSlugIndexRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.index"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites"
import { Route as AccountsAccountSlugTenantsTenantSlugSecretsRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.secrets"
import { Route as AccountsAccountSlugTenantsTenantSlugIdentityRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.identity"
import { Route as AccountsAccountSlugTenantsTenantSlugHaInstancesRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.ha-instances"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesIndexRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.index"
import { Route as AccountsAccountSlugTenantsTenantSlugSecretsIndexRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.secrets.index"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug"
import { Route as AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.secrets.$secretId"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.index"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.network"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.logical-groups"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.hosts"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.devices"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.areas"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.access"
import { Route as AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRouteImport } from "./../routes/accounts.$accountSlug.tenants.$tenantSlug.sites.$siteSlug.floors.$floorSlug"

const OnboardingRunsRoute = OnboardingRunsRouteImport.update({
  id: "/onboarding-runs",
  path: "/onboarding-runs",
  getParentRoute: () => rootRouteImport,
} as any)
const FleetRoute = FleetRouteImport.update({
  id: "/fleet",
  path: "/fleet",
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => rootRouteImport,
} as any)
const AllocationRoute = AllocationRouteImport.update({
  id: "/allocation",
  path: "/allocation",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsIndexRoute = AccountsIndexRouteImport.update({
  id: "/accounts/",
  path: "/accounts/",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsAccountSlugRoute = AccountsAccountSlugRouteImport.update({
  id: "/accounts/$accountSlug",
  path: "/accounts/$accountSlug",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountsAccountSlugIndexRoute =
  AccountsAccountSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AccountsAccountSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugRoute =
  AccountsAccountSlugTenantsTenantSlugRouteImport.update({
    id: "/tenants/$tenantSlug",
    path: "/tenants/$tenantSlug",
    getParentRoute: () => AccountsAccountSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugIndexRoute =
  AccountsAccountSlugTenantsTenantSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesRoute =
  AccountsAccountSlugTenantsTenantSlugSitesRouteImport.update({
    id: "/sites",
    path: "/sites",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSecretsRoute =
  AccountsAccountSlugTenantsTenantSlugSecretsRouteImport.update({
    id: "/secrets",
    path: "/secrets",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugIdentityRoute =
  AccountsAccountSlugTenantsTenantSlugIdentityRouteImport.update({
    id: "/identity",
    path: "/identity",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugHaInstancesRoute =
  AccountsAccountSlugTenantsTenantSlugHaInstancesRouteImport.update({
    id: "/ha-instances",
    path: "/ha-instances",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesIndexRoute =
  AccountsAccountSlugTenantsTenantSlugSitesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugSitesRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute =
  AccountsAccountSlugTenantsTenantSlugSecretsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugSecretsRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteImport.update({
    id: "/$siteSlug",
    path: "/$siteSlug",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugSitesRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute =
  AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRouteImport.update({
    id: "/$secretId",
    path: "/$secretId",
    getParentRoute: () => AccountsAccountSlugTenantsTenantSlugSecretsRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRouteImport.update({
    id: "/network",
    path: "/network",
    getParentRoute: () =>
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRouteImport.update(
    {
      id: "/logical-groups",
      path: "/logical-groups",
      getParentRoute: () =>
        AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
    } as any,
  )
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRouteImport.update({
    id: "/hosts",
    path: "/hosts",
    getParentRoute: () =>
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRouteImport.update({
    id: "/devices",
    path: "/devices",
    getParentRoute: () =>
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRouteImport.update({
    id: "/areas",
    path: "/areas",
    getParentRoute: () =>
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRouteImport.update({
    id: "/access",
    path: "/access",
    getParentRoute: () =>
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
  } as any)
const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRouteImport.update(
    {
      id: "/floors/$floorSlug",
      path: "/floors/$floorSlug",
      getParentRoute: () =>
        AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/allocation": typeof AllocationRoute
  "/audit": typeof AuditRoute
  "/fleet": typeof FleetRoute
  "/onboarding-runs": typeof OnboardingRunsRoute
  "/accounts/$accountSlug": typeof AccountsAccountSlugRouteWithChildren
  "/accounts/": typeof AccountsIndexRoute
  "/accounts/$accountSlug/": typeof AccountsAccountSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug": typeof AccountsAccountSlugTenantsTenantSlugRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances": typeof AccountsAccountSlugTenantsTenantSlugHaInstancesRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/identity": typeof AccountsAccountSlugTenantsTenantSlugIdentityRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets": typeof AccountsAccountSlugTenantsTenantSlugSecretsRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/sites": typeof AccountsAccountSlugTenantsTenantSlugSitesRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/": typeof AccountsAccountSlugTenantsTenantSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId": typeof AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/": typeof AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/": typeof AccountsAccountSlugTenantsTenantSlugSitesIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/allocation": typeof AllocationRoute
  "/audit": typeof AuditRoute
  "/fleet": typeof FleetRoute
  "/onboarding-runs": typeof OnboardingRunsRoute
  "/accounts": typeof AccountsIndexRoute
  "/accounts/$accountSlug": typeof AccountsAccountSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances": typeof AccountsAccountSlugTenantsTenantSlugHaInstancesRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/identity": typeof AccountsAccountSlugTenantsTenantSlugIdentityRoute
  "/accounts/$accountSlug/tenants/$tenantSlug": typeof AccountsAccountSlugTenantsTenantSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId": typeof AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets": typeof AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites": typeof AccountsAccountSlugTenantsTenantSlugSitesIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/allocation": typeof AllocationRoute
  "/audit": typeof AuditRoute
  "/fleet": typeof FleetRoute
  "/onboarding-runs": typeof OnboardingRunsRoute
  "/accounts/$accountSlug": typeof AccountsAccountSlugRouteWithChildren
  "/accounts/": typeof AccountsIndexRoute
  "/accounts/$accountSlug/": typeof AccountsAccountSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug": typeof AccountsAccountSlugTenantsTenantSlugRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances": typeof AccountsAccountSlugTenantsTenantSlugHaInstancesRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/identity": typeof AccountsAccountSlugTenantsTenantSlugIdentityRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets": typeof AccountsAccountSlugTenantsTenantSlugSecretsRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/sites": typeof AccountsAccountSlugTenantsTenantSlugSitesRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/": typeof AccountsAccountSlugTenantsTenantSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId": typeof AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteWithChildren
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/": typeof AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/": typeof AccountsAccountSlugTenantsTenantSlugSitesIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug": typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/allocation"
    | "/audit"
    | "/fleet"
    | "/onboarding-runs"
    | "/accounts/$accountSlug"
    | "/accounts/"
    | "/accounts/$accountSlug/"
    | "/accounts/$accountSlug/tenants/$tenantSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances"
    | "/accounts/$accountSlug/tenants/$tenantSlug/identity"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites"
    | "/accounts/$accountSlug/tenants/$tenantSlug/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/allocation"
    | "/audit"
    | "/fleet"
    | "/onboarding-runs"
    | "/accounts"
    | "/accounts/$accountSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances"
    | "/accounts/$accountSlug/tenants/$tenantSlug/identity"
    | "/accounts/$accountSlug/tenants/$tenantSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug"
  id:
    | "__root__"
    | "/"
    | "/allocation"
    | "/audit"
    | "/fleet"
    | "/onboarding-runs"
    | "/accounts/$accountSlug"
    | "/accounts/"
    | "/accounts/$accountSlug/"
    | "/accounts/$accountSlug/tenants/$tenantSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances"
    | "/accounts/$accountSlug/tenants/$tenantSlug/identity"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites"
    | "/accounts/$accountSlug/tenants/$tenantSlug/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug"
    | "/accounts/$accountSlug/tenants/$tenantSlug/secrets/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/"
    | "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AllocationRoute: typeof AllocationRoute
  AuditRoute: typeof AuditRoute
  FleetRoute: typeof FleetRoute
  OnboardingRunsRoute: typeof OnboardingRunsRoute
  AccountsAccountSlugRoute: typeof AccountsAccountSlugRouteWithChildren
  AccountsIndexRoute: typeof AccountsIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/onboarding-runs": {
      id: "/onboarding-runs"
      path: "/onboarding-runs"
      fullPath: "/onboarding-runs"
      preLoaderRoute: typeof OnboardingRunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/fleet": {
      id: "/fleet"
      path: "/fleet"
      fullPath: "/fleet"
      preLoaderRoute: typeof FleetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/audit": {
      id: "/audit"
      path: "/audit"
      fullPath: "/audit"
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/allocation": {
      id: "/allocation"
      path: "/allocation"
      fullPath: "/allocation"
      preLoaderRoute: typeof AllocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/accounts/": {
      id: "/accounts/"
      path: "/accounts"
      fullPath: "/accounts/"
      preLoaderRoute: typeof AccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/accounts/$accountSlug": {
      id: "/accounts/$accountSlug"
      path: "/accounts/$accountSlug"
      fullPath: "/accounts/$accountSlug"
      preLoaderRoute: typeof AccountsAccountSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/accounts/$accountSlug/": {
      id: "/accounts/$accountSlug/"
      path: "/"
      fullPath: "/accounts/$accountSlug/"
      preLoaderRoute: typeof AccountsAccountSlugIndexRouteImport
      parentRoute: typeof AccountsAccountSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug"
      path: "/tenants/$tenantSlug"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugRouteImport
      parentRoute: typeof AccountsAccountSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/"
      path: "/"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugIndexRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites"
      path: "/sites"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/secrets": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/secrets"
      path: "/secrets"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/secrets"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/identity": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/identity"
      path: "/identity"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/identity"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugIdentityRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances"
      path: "/ha-instances"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/ha-instances"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugHaInstancesRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/"
      path: "/"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesIndexRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/secrets/": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/secrets/"
      path: "/"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/secrets/"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsIndexRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug"
      path: "/$siteSlug"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId"
      path: "/$secretId"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/"
      path: "/"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network"
      path: "/network"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups"
      path: "/logical-groups"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/logical-groups"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts"
      path: "/hosts"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/hosts"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices"
      path: "/devices"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/devices"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas"
      path: "/areas"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access"
      path: "/access"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/access"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
    "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug": {
      id: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug"
      path: "/floors/$floorSlug"
      fullPath: "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/floors/$floorSlug"
      preLoaderRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRouteImport
      parentRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute
    }
  }
}

interface AccountsAccountSlugTenantsTenantSlugSecretsRouteChildren {
  AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute
  AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute
}

const AccountsAccountSlugTenantsTenantSlugSecretsRouteChildren: AccountsAccountSlugTenantsTenantSlugSecretsRouteChildren =
  {
    AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute:
      AccountsAccountSlugTenantsTenantSlugSecretsSecretIdRoute,
    AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute:
      AccountsAccountSlugTenantsTenantSlugSecretsIndexRoute,
  }

const AccountsAccountSlugTenantsTenantSlugSecretsRouteWithChildren =
  AccountsAccountSlugTenantsTenantSlugSecretsRoute._addFileChildren(
    AccountsAccountSlugTenantsTenantSlugSecretsRouteChildren,
  )

interface AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteChildren {
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute
}

const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteChildren: AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteChildren =
  {
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAccessRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugAreasRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugDevicesRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugHostsRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugLogicalGroupsRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugNetworkRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugIndexRoute,
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugFloorsFloorSlugRoute,
  }

const AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteWithChildren =
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute._addFileChildren(
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteChildren,
  )

interface AccountsAccountSlugTenantsTenantSlugSitesRouteChildren {
  AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteWithChildren
  AccountsAccountSlugTenantsTenantSlugSitesIndexRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesIndexRoute
}

const AccountsAccountSlugTenantsTenantSlugSitesRouteChildren: AccountsAccountSlugTenantsTenantSlugSitesRouteChildren =
  {
    AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRoute:
      AccountsAccountSlugTenantsTenantSlugSitesSiteSlugRouteWithChildren,
    AccountsAccountSlugTenantsTenantSlugSitesIndexRoute:
      AccountsAccountSlugTenantsTenantSlugSitesIndexRoute,
  }

const AccountsAccountSlugTenantsTenantSlugSitesRouteWithChildren =
  AccountsAccountSlugTenantsTenantSlugSitesRoute._addFileChildren(
    AccountsAccountSlugTenantsTenantSlugSitesRouteChildren,
  )

interface AccountsAccountSlugTenantsTenantSlugRouteChildren {
  AccountsAccountSlugTenantsTenantSlugHaInstancesRoute: typeof AccountsAccountSlugTenantsTenantSlugHaInstancesRoute
  AccountsAccountSlugTenantsTenantSlugIdentityRoute: typeof AccountsAccountSlugTenantsTenantSlugIdentityRoute
  AccountsAccountSlugTenantsTenantSlugSecretsRoute: typeof AccountsAccountSlugTenantsTenantSlugSecretsRouteWithChildren
  AccountsAccountSlugTenantsTenantSlugSitesRoute: typeof AccountsAccountSlugTenantsTenantSlugSitesRouteWithChildren
  AccountsAccountSlugTenantsTenantSlugIndexRoute: typeof AccountsAccountSlugTenantsTenantSlugIndexRoute
}

const AccountsAccountSlugTenantsTenantSlugRouteChildren: AccountsAccountSlugTenantsTenantSlugRouteChildren =
  {
    AccountsAccountSlugTenantsTenantSlugHaInstancesRoute:
      AccountsAccountSlugTenantsTenantSlugHaInstancesRoute,
    AccountsAccountSlugTenantsTenantSlugIdentityRoute:
      AccountsAccountSlugTenantsTenantSlugIdentityRoute,
    AccountsAccountSlugTenantsTenantSlugSecretsRoute:
      AccountsAccountSlugTenantsTenantSlugSecretsRouteWithChildren,
    AccountsAccountSlugTenantsTenantSlugSitesRoute:
      AccountsAccountSlugTenantsTenantSlugSitesRouteWithChildren,
    AccountsAccountSlugTenantsTenantSlugIndexRoute:
      AccountsAccountSlugTenantsTenantSlugIndexRoute,
  }

const AccountsAccountSlugTenantsTenantSlugRouteWithChildren =
  AccountsAccountSlugTenantsTenantSlugRoute._addFileChildren(
    AccountsAccountSlugTenantsTenantSlugRouteChildren,
  )

interface AccountsAccountSlugRouteChildren {
  AccountsAccountSlugIndexRoute: typeof AccountsAccountSlugIndexRoute
  AccountsAccountSlugTenantsTenantSlugRoute: typeof AccountsAccountSlugTenantsTenantSlugRouteWithChildren
}

const AccountsAccountSlugRouteChildren: AccountsAccountSlugRouteChildren = {
  AccountsAccountSlugIndexRoute: AccountsAccountSlugIndexRoute,
  AccountsAccountSlugTenantsTenantSlugRoute:
    AccountsAccountSlugTenantsTenantSlugRouteWithChildren,
}

const AccountsAccountSlugRouteWithChildren =
  AccountsAccountSlugRoute._addFileChildren(AccountsAccountSlugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AllocationRoute: AllocationRoute,
  AuditRoute: AuditRoute,
  FleetRoute: FleetRoute,
  OnboardingRunsRoute: OnboardingRunsRoute,
  AccountsAccountSlugRoute: AccountsAccountSlugRouteWithChildren,
  AccountsIndexRoute: AccountsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
